/*
 *  -----------------------------------------------------------------------
 *    <copyright file="schedule-versions-grid.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { GridColumnMenuActiveFilter } from '@components/core/grid-filters';
import { GridColumnDateFilterV2 } from '@components/core/grid-filters-v2';
import { useGridCells } from '@hooks/index';

const { YesNoCell, NumberCell, DateCell, MaxLengthCell } = useGridCells();

export const SCHEDULE_VERSIONS_GRID_COLUMNS = (translate: Function) => [
    {
        field: 'recordId',
        label: translate('id'),
        minWidth: 150,
        id: 'schedule-id',
        filter: 'numeric',
        cells: { data: NumberCell },
        showByDefault: false,
    },
    {
        label: translate('common:active'),
        field: 'active',
        id: 'schedule-active',
        minWidth: 160,
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        label: translate('common:version'),
        id: 'schedule-version',
        field: 'version',
        cells: { data: MaxLengthCell(30) },
        minWidth: 160,
    },
    {
        label: translate('common:description'),
        field: 'description',
        id: 'schedule-description',
        minWidth: 190,
        cells: { data: MaxLengthCell(50) },
    },
    {
        label: translate('common:effectiveDate'),
        id: 'schedule-effective-date',
        minWidth: 200,
        field: '_effectiveDate',
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
    {
        label: translate('ra:createdBy'),
        id: 'schedule-createdby',
        field: '_createdByString',
        minWidth: 180,
    },
    {
        label: translate('ra:createdDate'),
        id: 'schedule-created',
        minWidth: 200,
        field: 'created',
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
    {
        label: translate('ra:updatedBy'),
        id: 'schedule-updatedby',
        field: '_updatedByString',
        minWidth: 180,
    },
    {
        label: translate('ra:updatedDate'),
        field: 'updated',
        id: 'schedule-updated',
        minWidth: 200,
        filter: 'date',
        cells: { data: DateCell },
        filterUi: GridColumnDateFilterV2,
    },
];
